import React from "react";
import logo from "../assets/logo.png";

export const Logo = ({ className = "" }) => {
  return (
    <div
      className={`flex items-center ${className}`}
      data-testid="brand-logo"
    >
      <img
        src={logo}
        alt="Company Logo"
        className="h-12 w-auto"
      />
    </div>
  );
};

export default Logo;
